"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectName = exports.ErrorCode = void 0;
exports.ErrorCode = {
    BadRequest: 'bad_request',
    NotAllowed: 'not_allowed',
    NotFound: 'not_found',
    Forbidden: 'forbidden',
    TooManyRequests: 'too_many_requests',
    Unauthorized: 'unauthorized',
    Unprocessable: 'unprocessable',
};
exports.ProjectName = {
    Widget: 'widget',
    Chatbot: 'chatbot',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBWWEsUUFBQSxTQUFTLEdBQUc7SUFDeEIsVUFBVSxFQUFFLGFBQWE7SUFDekIsVUFBVSxFQUFFLGFBQWE7SUFDekIsUUFBUSxFQUFFLFdBQVc7SUFDckIsU0FBUyxFQUFFLFdBQVc7SUFDdEIsZUFBZSxFQUFFLG1CQUFtQjtJQUNwQyxZQUFZLEVBQUUsY0FBYztJQUM1QixhQUFhLEVBQUUsZUFBZTtDQUNyQixDQUFBO0FBeUJHLFFBQUEsV0FBVyxHQUFHO0lBQzFCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLE9BQU8sRUFBRSxTQUFTO0NBQ1QsQ0FBQSJ9